<div class="login-static">
	<img src="../../../assets/img/login_background.png" alt="R.A.M. Consulting">

	<!-- form di accesso sovrapposto alla card disegnata nell'immagine di sfondo -->
	<form class="login-card" *ngIf="formGroup" [formGroup]="formGroup" (ngSubmit)="login()">
		<h1 class="login-title">{{'login' | translate}}</h1>

		<label class="login-label" for="loginUtente">{{'utente' | translate}}</label>
		<div class="login-field">
			<i class="far fa-user"></i>
			<input id="loginUtente" type="text" formControlName="utente" autocomplete="username"
				[placeholder]="'tuoNomeUtente' | translate">
		</div>

		<label class="login-label" for="loginPassword">{{'password' | translate}}</label>
		<div class="login-field">
			<i class="fas fa-lock"></i>
			<input id="loginPassword" type="password" formControlName="password" autocomplete="current-password"
				[placeholder]="'tuaPassword' | translate">
		</div>

		<button type="button" class="login-forgot" (click)="openPasswordDimenticataDialog()">
			{{'passwordDimenticata' | translate}}
		</button>

		<button type="submit" class="login-submit" [disabled]="formGroup.invalid || isSpinnerActivated">
			<i class="fas fa-sign-in-alt"></i>
			<span>{{'accedi' | translate}}</span>
		</button>
	</form>
</div>

<spinner></spinner>
<password-dimenticata-dialog #passwordDimenticataDialog></password-dimenticata-dialog>
<password-scaduta-dialog #passwordScadutaDialog></password-scaduta-dialog>